<main class="flex flex-grow flex-col space-y-4 overflow-y-auto px-9 pb-10 pt-5">
  <slot />
</main>
